import React, { memo } from 'react'
import { css } from 'styled-components/macro'
import { Box } from '@alobato/flex-box'
import Text from '@alobato/text'
import { Table, TableContainer, TableRow, TableCell, TableHeaderRow, TableHeaderCell } from '../../components/DataTable'
import { EmptyState } from '../../components/ui'
import MenuOver from '../../components/MenuOver'
import { MoreIcon } from '../../components/Icons'

const List = ({ items, navigate, deleteItem }) => {

  const handleMenuOverClick = (action, id) => {
    switch (action) {
      case 'delete':
        deleteItem(id)
        break
      case 'show':
        navigate(`${id}`)
        break
      case 'edit':
        navigate(`${id}/editar`)
        break
      case 'doctors':
        navigate(`${id}/medicos`)
        break
      default:
        return false
    }
  }

  return (
    <>
      <Box mb={5}>
        {!!items.length ? (
          <TableContainer>
            <Table>
              <TableHeaderRow>
                <TableHeaderCell>Nome</TableHeaderCell>
                <TableHeaderCell>Email</TableHeaderCell>
                <TableHeaderCell></TableHeaderCell>
              </TableHeaderRow>
              {items.map(item => (
                <TableRow key={item.id}>
                  <TableCell data-title='Nome'>{item.name}</TableCell>
                  <TableCell data-title='Email'>{item.login}</TableCell>
                  <TableCell width={40} lineHeight={0}>
                    <MenuOver
                      options={[{label: 'Detalhes', value: 'show'}, {label: 'Editar', value: 'edit'}, {label: 'Médicos', value: 'doctors'}, {label: 'Excluir', value: 'delete'}]}
                      onSelect={action => handleMenuOverClick(action, item.id)}
                    >
                      <MoreIcon style={{cursor: 'pointer'}} />
                    </MenuOver>
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </TableContainer>
        ) : (
          <EmptyState />
        )}
      </Box>
    </>
  )
}

export default memo(List)
